import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * åéæ¶æ¯ç»FormLoadingServiceï¼
 * ä½¿å¶æ¥æ¶åè°ç¨hide()å½æ°
 * æ­¤æå¡ä»ç¨äºå¤çHttpå¼å¸¸
 */
@Injectable()
class HideEventService {
    public hideEvent = new Subject<any>();
}

export { HideEventService };